/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanyMetadataLLMDto,
} from '../models/index';
import {
    CompanyMetadataLLMDtoFromJSON,
    CompanyMetadataLLMDtoToJSON,
} from '../models/index';

export interface MetadataGetMetadataGETRequest {
    companyId?: string;
}

/**
 * MetadataApi - interface
 * 
 * @export
 * @interface MetadataApiInterface
 */
export interface MetadataApiInterface {
    /**
     * Creates request options for metadataGetMetadataGET without sending the request
     * @param {string} [companyId] 
     * @throws {RequiredError}
     * @memberof MetadataApiInterface
     */
    metadataGetMetadataGETRequestOpts(requestParameters: MetadataGetMetadataGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [companyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApiInterface
     */
    metadataGetMetadataGETRaw(requestParameters: MetadataGetMetadataGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyMetadataLLMDto>>;

    /**
     */
    metadataGetMetadataGET(requestParameters: MetadataGetMetadataGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyMetadataLLMDto>;

}

/**
 * 
 */
export class MetadataApi extends runtime.BaseAPI implements MetadataApiInterface {

    /**
     * Creates request options for metadataGetMetadataGET without sending the request
     */
    async metadataGetMetadataGETRequestOpts(requestParameters: MetadataGetMetadataGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Metadata`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async metadataGetMetadataGETRaw(requestParameters: MetadataGetMetadataGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyMetadataLLMDto>> {
        const requestOptions = await this.metadataGetMetadataGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyMetadataLLMDtoFromJSON(jsonValue));
    }

    /**
     */
    async metadataGetMetadataGET(requestParameters: MetadataGetMetadataGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyMetadataLLMDto> {
        const response = await this.metadataGetMetadataGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
